import { Icon } from "@iconify/react";
import { Button } from "../../components";
import ModalWrapper from "./Modal";
import styles from "./Modal.module.css";

function ErrorModal({ handleClose, isVisible, message, name }) {
  return (
    <ModalWrapper isVisible={isVisible} onClose={handleClose} name={name} level={2}>
      <div className="column">
        <Icon icon="heroicons:exclaimation-triangle" className={styles.error_icon} />
        <div className={styles.error_message}>{message}</div>
        <Button className="cancel" onClick={handleClose} center>
          Close
        </Button>
      </div>
    </ModalWrapper>
  );
}

export default ErrorModal;
